@use '@lib/assets/styles/main.scss' as *;

.versionNotesContent {
  border: 1px solid $gray100;
  border-radius: 6px;
  padding: 16px;
  overflow-y: auto;
}

.textEditor {
  min-height: unset;
}
